import $ from "jquery";
$(function () {
  $("body").on("click", ".snl-print-button", function () {
    window.print();
  });
});